import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
export const TranslatedHtmlContent = ({
  htmlContent
}) => {
  return /*#__PURE__*/_jsx("span", {
    dangerouslySetInnerHTML: {
      __html: formatHtml(htmlContent)
    }
  });
};